export default "__VITE_ASSET__eCmtgqzk__"